import { inject, Injectable } from '@angular/core';
import { AuthBagService } from './auth-bag.service';

@Injectable({ providedIn: 'root' })
export class AppInitService {
	private readonly authBagService = inject(AuthBagService);

	initialize(): Promise<void> {
		const access = this.authBagService.tokenGet();
		const refresh = this.authBagService.tokenRefreshGet();

		if (!access || !refresh) {
			this.authBagService.authStatus$.next(false);
			return Promise.resolve();
		}

		return this.authBagService
			.authenticate({ access, refresh })
			.then(() => {
				console.log('[AppInit] Authenticated from stored tokens');
			})
			.catch((error) => {
				console.warn('[AppInit] Token authentication failed', error);
				this.authBagService.authStatus$.next(false);
			});
	}
}
